import { useState } from 'react';
import { useQuery } from 'urql';
import PageHeader from '../../../components/PageHeader.jsx';
import { LIST_USERS_QUERY, LIST_SESSIONS_QUERY } from './gql.js';

export default function SesionesList() {
  const [{ data: usersData, fetching: loadingUsers, error: usersError }] = useQuery({ query: LIST_USERS_QUERY });
  const [selectedUser, setSelectedUser] = useState(null);
  const [{ data: sessionsData, fetching: loadingSessions }] = useQuery({
    query: LIST_SESSIONS_QUERY,
    variables: { userId: selectedUser?.id ?? '' },
    pause: !selectedUser,
  });

  const users = usersData?.listUsers ?? [];
  const sessions = sessionsData?.listSessions ?? [];

  return (
    <div className="min-h-screen w-full bg-[rgb(var(--bg))] pb-16">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-8 px-6 pt-10">
        <PageHeader title="Sesiones activas" subtitle="Controlá los dispositivos conectados y revocá accesos en segundos." />
        <section className="card grid gap-6 p-6 lg:grid-cols-[320px_1fr]">
          <div className="rounded-2xl border border-[rgba(var(--border),0.45)] bg-[rgba(var(--subpanel),0.7)] p-4">
            <h2 className="text-sm font-semibold uppercase tracking-wide text-[rgba(var(--muted),0.9)]">Usuarios</h2>
            {loadingUsers ? (
              <p className="mt-4 text-sm text-[rgba(var(--muted),0.9)]">Cargando usuarios...</p>
            ) : usersError ? (
              <p className="mt-4 text-sm text-red-500">{usersError.message}</p>
            ) : (
              <ul className="mt-4 space-y-2">
                {users.map((user) => (
                  <li key={user.id}>
                    <button
                      type="button"
                      onClick={() => setSelectedUser(user)}
                      className={`w-full rounded-xl border px-4 py-3 text-left text-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] ${
                        selectedUser?.id === user.id
                          ? 'border-[rgba(var(--brand),0.5)] bg-[rgba(var(--brand),0.16)] text-[rgb(var(--brand))]'
                          : 'border-[rgba(var(--border),0.6)] text-[rgb(var(--fg))] hover:border-[rgba(var(--brand),0.4)]'
                      }`}
                    >
                      <span className="block font-semibold">{user.nombre} {user.apellido}</span>
                      <span className="text-xs text-[rgba(var(--muted),0.9)]">{user.email}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="rounded-2xl border border-[rgba(var(--border),0.45)] bg-[rgba(var(--panel),0.7)] p-4">
            <header className="mb-4 flex items-center justify-between">
              <div>
                <h2 className="text-base font-semibold text-[rgb(var(--fg))]">
                  {selectedUser ? `${selectedUser.nombre} ${selectedUser.apellido}` : 'Seleccioná un usuario'}
                </h2>
                <p className="text-xs text-[rgba(var(--muted),0.9)]">
                  {selectedUser ? 'Sesiones con token activo. Revocá para forzar logout.' : 'Elegí un usuario para ver sus sesiones.'}
                </p>
              </div>
            </header>
            {selectedUser ? (
              loadingSessions ? (
                <p className="text-sm text-[rgba(var(--muted),0.9)]">Buscando sesiones...</p>
              ) : sessions.length === 0 ? (
                <p className="text-sm text-[rgba(var(--muted),0.9)]">Sin sesiones activas.</p>
              ) : (
                <ul className="space-y-3">
                  {sessions.map((session) => (
                    <li key={session.id} className="rounded-xl border border-[rgba(var(--border),0.35)] bg-[rgba(var(--panel),0.85)] p-4">
                      <div className="flex flex-wrap items-center justify-between gap-3">
                        <div>
                          <p className="text-sm font-semibold text-[rgb(var(--fg))]">{session.userAgent ?? 'Sin user agent'}</p>
                          <p className="text-xs text-[rgba(var(--muted),0.9)]">IP: {session.ip ?? '—'}</p>
                        </div>
                        <span className={`rounded-full px-3 py-1 text-xs font-semibold ${session.revocado ? 'bg-[rgba(var(--muted),0.2)] text-[rgba(var(--muted),0.85)]' : 'bg-[rgba(var(--brand),0.16)] text-[rgb(var(--brand))]'}`}>
                          {session.revocado ? 'Revocada' : 'Activa'}
                        </span>
                      </div>
                      <dl className="mt-3 grid grid-cols-1 gap-2 text-xs text-[rgba(var(--muted),0.85)] sm:grid-cols-2">
                        <div>
                          <dt className="font-semibold">Creada</dt>
                          <dd>{new Date(session.creadoEn).toLocaleString()}</dd>
                        </div>
                        <div>
                          <dt className="font-semibold">Expira</dt>
                          <dd>{new Date(session.expiraEn).toLocaleString()}</dd>
                        </div>
                      </dl>
                    </li>
                  ))}
                </ul>
              )
            ) : (
              <p className="text-sm text-[rgba(var(--muted),0.9)]">Elegí una persona para cargar sesiones activas.</p>
            )}
          </div>
        </section>
        <section className="card p-4 text-sm text-[rgba(var(--fg),0.78)]">
          La vista ya permite revisar sesiones activas por usuario. Si el backend expone revocación individual, este bloque puede sumar la acción sin cambiar la estructura de la pantalla.
        </section>
      </div>
    </div>
  );
}
